import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@fiverr-private/fit';

function SafeAvatar({ username, ...otherProps }) {
    const safeUserName = username ? username : 'A';

    return (
        <Avatar username={safeUserName} {...otherProps}/>
    );
}

SafeAvatar.propTypes = {
    username: PropTypes.string
};

export default SafeAvatar;
